import type { App } from 'vue'
import Toast from 'vue-toastification'
import { asyncGetContainer } from '@/utils/build'

export const install = (app: App) => {
  app.use(Toast, {
    container: asyncGetContainer,
  })
}
